import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsCreate from '../../api/ManualPreadviceTransactionsCreateAPI';
import { MPA_TRANSACTIONS_CREATE_REQUEST } from '../actions/types/ManualPreadviceTransactionsCreateActionsTypes';
import { postManualPreadviceTransactionsCreateSuccessActionCreator, postManualPreadviceTransactionsCreateFailureActionCreator } from '../actions/ManualPreadviceTransactionsCreateActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doMpaTransactionsCreateWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchManualPreadviceTransactionsCreate, action.payload);
    yield put(postManualPreadviceTransactionsCreateSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.manualpreadvicetransactions.create.success'),
    }));
  } catch (error) {
    yield put(postManualPreadviceTransactionsCreateFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doMpaTransactionsCreateWatcher() {
  yield takeLatest(MPA_TRANSACTIONS_CREATE_REQUEST, doMpaTransactionsCreateWorker);
}

export default doMpaTransactionsCreateWatcher;
